import { Text } from "../../../../text";
import { NotFoundLabelProps } from "./types";
import styles from "./styles.module.scss";

export const NotFoundLabel = ({ text, dataTestId }: NotFoundLabelProps) => (
  <li
    className={styles["not-found-label"]}
    data-test-id={`${dataTestId}-not-found-label`}
  >
    <Text className={styles.text}>{text}</Text>
  </li>
);
